import '../styles/NomDirGen.css';

function NomDirGen() {
    return (
        <h2 className="nom-dir-gen">Dirección General de Recursos Materiales y Servicios Generales</h2>
    );
}

export default NomDirGen;